import React from 'react';
import BaseComponent from './BaseComponent';
import classNames from 'classnames';
import {Link} from 'react-router';

/*
<List>
    <ListItem to="">
        <ListBody>
            <ListTitle />
            <ListContent />
        </ListBody>
        <ListBody>
            <ListTitle />
            <ListContent />
        </ListBody>
    </ListItem>
</List>
*/

export class List extends BaseComponent {
    render() {
        const className = classNames('ui-list', this.props.className);

        return <div className={className}>
            {this.props.children}
        </div>
    }
}

export class ListItem extends BaseComponent {
    static get PropTypes() {
        return {
            to: React.PropTypes.string,
            className: React.PropTypes.string,
        }
    }

    render() {
        const {to} = this.props;
        let {children} = this.props;

        const className = classNames('ui-list-item', {active: this.props.active}, this.props.className);

        if (to) {
            children = <Link className="ui-list-item-inner" to={to}>{children}</Link>
        }
        else {
            children = <div className="ui-list-item-inner">{children}</div>
        }

        return <div className={className}>
            {children}
        </div>;
    }
}

export class ListBody extends BaseComponent {
    static get PropTypes() {
        return {
            align: React.PropTypes.oneOf(["left", "right", "center"]).isRequired,
            valign: React.PropTypes.oneOf(["top", "middle", "bottom"]).isRequired,
            flex: React.PropTypes.bool.isRequired,
            className: React.PropTypes.string,
        };
    }

    static get defaultProps() {
        return {
            align: "left",
            valign: "top",
            flex: true,
        };
    }

    render() {
        const {children, align, valign, flex} = this.props;
        const className = classNames('ui-list-body', this.props.className, {
            "ui-bottom": valign === 'bottom',
            "ui-middle": valign === 'middle',
            "ui-right": align === 'right',
            "ui-center": align === 'center',
            "ui-flex": flex,
        });

        return <div className={className}>{children}</div>;
    }
}

export const ListTitle = ({children, foo}) => <div className="ui-list-title">{children} {foo}</div>;
export const ListContent = ({children}) => <div className="ui-list-content">{children}</div>;



/** WEBPACK FOOTER **
 ** ./src/components/UIList.jsx
 **/